import { render } from "./itinerario_ingles.vue?vue&type=template&id=3150ea48&scoped=true"
import script from "./itinerario_ingles.vue?vue&type=script&lang=js"
export * from "./itinerario_ingles.vue?vue&type=script&lang=js"

import "./itinerario_ingles.vue?vue&type=style&index=0&id=3150ea48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3150ea48"]])

export default __exports__